// ABOUTME: React context for sharing navigation state across sub-components
// ABOUTME: Eliminates prop drilling between the orchestrator and desktop/mobile components
import { createContext, useContext } from "react"

import type { useNavigationState } from "./useNavigationState"

export type NavigationContextValue = ReturnType<typeof useNavigationState>

export const NavigationContext = createContext<NavigationContextValue | null>(
	null,
)

export const useNavigationContext = (): NavigationContextValue => {
	const ctx = useContext(NavigationContext)
	if (!ctx) {
		throw new Error(
			"useNavigationContext must be used within NavigationContext.Provider",
		)
	}
	return ctx
}
